"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classnames = require("classnames"); // tslint:disable-line no-require-imports
exports.classNames = classnames;
function variationName(name, value) {
    var valuePortion = typeof value === 'number' ? String(value) : "" + value[0].toUpperCase() + value.substring(1);
    return "" + name + valuePortion;
}
exports.variationName = variationName;



//////////////////
// WEBPACK FOOTER
// ./~/@shopify/react-utilities/styles.js
// module id = 183
// module chunks = 0